import { Theme } from './types';

export const lightTheme: Theme = {
  colors: {
    background: "#f0f0f0",
    text: "#333",
    mutedText: "#555",
    hourlyItemBackground: "#e0e0e0",
    cardShadow: "rgba(0, 0, 0, 0.4)",
    toggleThemeBg: "#48484a",
    search: {
      shadow: "rgba(0, 0, 0, 0.15)",
      shadowFocus: "rgba(0, 0, 0, 0.3)",
      btnBackground: "#48484a",
      btnText: "#fff",
      btnHover: "#323235",
    },
    suggestionList: {
      background: "#e0e0e0",
      itemHover: "#ccc",
      border: "#666",
      itemBorderBottom: "#aaa"
    },
  },
};